import React, { useContext } from 'react';
import { Form } from 'react-bootstrap';
import { ChatContext } from 'context/Context';
import TextareaAutosize from 'react-textarea-autosize';
import Loading from './Loading';
import MessageFunctions from './MessageFunctions';

const MessageTextArea = () => {
  const { message, setMessage, chatsLoading, handleSubmitStream, textareaElement } = useContext(ChatContext);

  return (
    <div className='bottom-0 position-absolute w-100'>
      {chatsLoading && <div className='align-self-baseline text-center'><Loading /></div>}
      <Form className="chat-editor-area" onSubmit={e => handleSubmitStream(e)}>
        <TextareaAutosize
          disabled={chatsLoading}
          minRows={2}
          value={message}
          placeholder="Type your message"
          onChange={({ target }) => setMessage(target.value)}
          ref={textareaElement}
          className="form-control resize-none rounded-0 outline-none border-1 me-0 pe-0"
          onKeyDown={e => { if (e.key == 'Enter' && !chatsLoading) handleSubmitStream(e) }}
        />
        <MessageFunctions />
      </Form>
    </div>
  );
};

export default MessageTextArea;
